export default "__VITE_ASSET__ZCX1yqGF__"